import { render, staticRenderFns } from "./DialogTempoRetirada.vue?vue&type=template&id=ff696fa8&scoped=true&lang=pug"
import script from "./DialogTempoRetirada.vue?vue&type=script&lang=js"
export * from "./DialogTempoRetirada.vue?vue&type=script&lang=js"
import style0 from "./DialogTempoRetirada.vue?vue&type=style&index=0&id=ff696fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff696fa8",
  null
  
)

export default component.exports